module.exports = __webpack_public_path__ + "static/media/video-svgrepo-com.6e219e94.svg";